import FileManagement from "../real-gain/rag/FileManagement";
import { authenticationAtom } from "../State";
import { useAtom } from "jotai";
import { useModalContext } from "../components/ModalProvider";


/**
 * Rahmen der Dateiverwaltung im Bereich „Einstellungen“. Der Baustein selbst
 * enthält keine Oberfläche — er reicht Anmeldung und Meldungskanäle an
 * `real-gain/rag/FileManagement` durch und setzt nur den Layout-Rahmen:
 * volle Breite und volle Resthöhe (`flex-1` + `min-h-0`), damit der
 * Datei-Manager den Panel-Bereich bis zur Fensterunterkante ausfüllt und
 * seine Panes intern scrollen.
 */
export default function FileManagementPanel() {
  const [authentication] = useAtom(authenticationAtom) as any;
  const { pushError, showDeleteDialog } = useModalContext() as any;
  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col">
      <FileManagement
        authentication={authentication}
        pushError={pushError}
        showDeleteDialog={showDeleteDialog}
      ></FileManagement>
    </div>
  );
}